<script setup>

    // Future idea: use Bootstrap accordion for the extra Teilnehmer detail?

    import { ref, watchEffect } from 'vue';
    import { getFromAPI, buildPageFooter, isButtonDisabled } from '../../functionCollection.js';
    import TeilnehmerTarifChange from './TeilnehmerTarifChange.vue'; //will be used in a modal triggered by the button press.
    import Swal from 'sweetalert2';
    import axios from 'axios';

    const props = defineProps(['fetchUrl', 'userNumber', 'maxTeilnehmer', 'changeTarifUrl', 'getTeilnehmerUrl', 'isAdmin']);
    const teilnehmerInfo = ref(null);
    const columnsToFetch = "Teilnehmer,Monatspauschale,ma_status,Vertragsbeginn,Vertragsende,Tarifbezeichnung,Kartennummer"; //needed colums from Teilnehmer database.
    const teilnehmerToChange = ref(null);

    // needed for the page footer
    const currentPage = ref(1);
    const maxPageNumber = ref(1);
    const footerPageNumbers = ref(new Array());

    // get the Teilnehmer list content from TeilnehmerController@getTable, build page list footer
    watchEffect(async () => {
        const url = getFullUrl(props.fetchUrl, props.userNumber);
        teilnehmerInfo.value = await getFromAPI(url);
        maxPageNumber.value = teilnehmerInfo.value.meta.last_page;
        teilnehmerInfo.value = teilnehmerInfo.value.data;
        footerPageNumbers.value = buildPageFooter(currentPage.value, maxPageNumber.value);
    });

    // complete the URL. the values in the last concat specify which page we want,
    // as well as which columns from Teilneher we need, and how many entries we want per page.
    function getFullUrl(url) {
        return url.concat('/').concat(props.userNumber).concat(`?page=${currentPage.value}&columns=${columnsToFetch}&column=Teilnehmer&order=asc&per_page=10`);
    }

    // calls new Teilnehmer info whenever a page change is requested (i.e. a page button is pressed in the footer)
    async function getNewPage(newPage) {
        currentPage.value = newPage;
        if (currentPage.value < 1) {
            currentPage.value = 1;
        }
        teilnehmerInfo.value = await getFromAPI(getFullUrl(props.fetchUrl));
        footerPageNumbers.value = buildPageFooter(currentPage.value, maxPageNumber.value);
    }

    const selectedTeilnehmerChanges = ref([]);

    function showChangesModal(teilnehmer) {
      selectedTeilnehmerChanges.value = teilnehmer.future_changes;
      const modal = new bootstrap.Modal(document.getElementById('futureChangesModal'));
      modal.show();
    }

    function formatDate(dateString) {
      var temp = new Date(dateString);

       return temp.toLocaleDateString('de-DE', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
    })
}

    function getChangeStatus(changeDate) {
      const today = new Date();
      const changeTime = new Date(changeDate);
      const diffDays = Math.ceil((changeTime - today) / (1000 * 60 * 60 * 24));

      if (diffDays <= 5) return 'danger';
      if (diffDays <= 30) return 'warning';
      return 'normal';
    }

    async function handleTarifChanged({ reload }) {
        if (reload) {
            try {
                const currentPageNumber = currentPage.value;

                const result = await getFromAPI(getFullUrl(props.fetchUrl));
                teilnehmerInfo.value = result.data;
                maxPageNumber.value = result.meta.last_page;
                footerPageNumbers.value = buildPageFooter(currentPageNumber, maxPageNumber.value);

                const modalElement = document.getElementById('modalTeilnehmerTarifChange');
                const modalInstance = bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) {
                    modalInstance.hide();
                    modalElement.addEventListener('hidden.bs.modal', () => {
                        modalElement.removeAttribute('aria-hidden');
                    }, { once: true });
                }
            } catch (error) {
                console.error('Error reloading data:', error);
            }
        }
    }


const isLoadingDelete = ref(false);

async function deleteTarifChange(id) {
  Swal.fire({
    title: "Tarifänderung löschen?",
    text: "Wenn Sie eine wartende Tarifänderung löschen, wird diese nicht mehr durchgeführt.",
    icon: 'warning',
    confirmButtonText: "Löschen",
    confirmButtonColor: "#e64942",
    showCancelButton: true,
    cancelButtonText: "Abbrechen",
    focusCancel: true,
    reverseButtons: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      isLoadingDelete.value = true;
      try {
        const url = `/tarifaendernliste/${id}`;
        const res = await axios.delete(url);
        if (res.status === 200) {
          Swal.fire({
            title: 'Löschen erfolgreich',
            text: 'Tarifänderung wurde erfolgreich gelöscht!',
            icon: 'success',
          }).then(() => {
            teilnehmerInfo.value = teilnehmerInfo.value.map(teilnehmer => {
              if (teilnehmer.future_changes) {
            teilnehmer.future_changes = teilnehmer.future_changes.filter(change => change.id !== id);
              }
              return teilnehmer;
            });
            selectedTeilnehmerChanges.value = selectedTeilnehmerChanges.value.filter(change => change.id !== id);
            selectedTeilnehmerChanges.value = [...selectedTeilnehmerChanges.value];
        });
        }
      } catch (error) {
        Swal.fire({
          title: 'Löschen fehlgeschlagen!',
          text: 'Leider ist das Löschen fehlgeschlagen. ' + (error.response?.data?.message || ''),
          icon: 'error',
        });
      } finally {
        isLoadingDelete.value = false;
      }
    }
  });
}


</script>

<template>
    <div class="well">
        <div class="main-table" v-if="teilnehmerInfo">
            <div class="inner-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="table-head">ID</th>
                            <th class="table-head">Monatspauschale</th>
                            <th class="table-head">Status</th>
                            <th style="min-width: 270px;" class="table-head">Aktionen</th>
                        </tr>
                    </thead>

                    <!--
                        Generate these dynamically. There's no other way. Go through v-for with any key. Corresponds here to Teilnehmer ID
                        simply because Teilnehmer IDs are also sequential, but not directly related.
                    -->
                    <tbody v-for="teilnehmer of teilnehmerInfo" :key="teilnehmer.id">
                        <tr class="m-datatable__row">
                            <td>{{ teilnehmer.Teilnehmer }}</td>
                            <td>{{ teilnehmer.Monatspauschale }}</td>
                            <td>{{ teilnehmer.ma_status }}</td>
                            <td >
                                <div style="display:flex; align-items: flex-end;justify-content: flex-end;">

                                  <div style="display:flex;">
                                    <button
                                        v-if="teilnehmer.future_changes && teilnehmer.future_changes.length > 0"
                                        class="btn btn-primary"
                                        style="padding:6px 13px; font-family:emoji; font-weight: bold; margin-right:5px;"
                                        @click="showChangesModal(teilnehmer)"
                                    >
                                        i
                                    </button>
                                    <a v-if="props.isAdmin === 'true'"
                                      :href="`/teilnehmeredit/${props.userNumber}/${teilnehmer.Teilnehmer}`"
                                      class="btn btn-primary"
                                      style="padding: 6px 10px; margin-right: 5px;"
                                    >
                                      <i class="fa-solid fa-user"></i>
                                    </a>
                                  </div>
                                  <button
                                      type="button"
                                      class="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#modalTeilnehmerTarifChange"
                                      @click="teilnehmerToChange = teilnehmer.Teilnehmer"
                                  >
                                      Tarif anpassen
                                  </button>
                                    <div style=" margin-left: 3px;">
                                        <i  class="fa-solid fa-caret-down fa-lg"
                                            data-bs-toggle="collapse"
                                            :data-bs-target="'#dropdown' + teilnehmer.Teilnehmer"
                                            aria-expanded="false"
                                            :aria-controls="'dropdown' + teilnehmer.Teilnehmer">
                                        </i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <!-- sub table for additional info, deployed by the icon above.
                            while the class is called "dropdown", it is not actually a Bootstrap dropdown, but instead a collapse.
                            "Historisch gewachsen." Changing the name means changing the CSS, a risk I am not willing to take because
                            it might break tons of other things.
                        -->
                        <tr class="table-dropdown-row collapse"
                            :id="'dropdown' + teilnehmer.Teilnehmer">
                            <div class="table-dropdown"
                                style="height: 160.2px;">
                                <tr>
                                    <th>Vertragsbeginn:</th>
                                    <td>{{ teilnehmer.Vertragsbeginn }}</td>
                                </tr>
                                <tr  v-if="props.isAdmin === 'true'">
                                    <th>Vertragsende:</th>
                                    <td>{{ teilnehmer.Vertragsende }}</td>
                                </tr>
                                <tr>
                                    <th>Tarifbezeichnung:</th>
                                    <td>{{ teilnehmer.Tarifbezeichnung }}</td>
                                </tr>
                                <tr>
                                    <th>Kartennummer:</th>
                                    <td>{{ teilnehmer.Kartennummer }}</td>
                                </tr>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- The page selection footer. Each button is disabled under specific conditions, detailed at the corresponding functions. -->
        <div class="table-footer middle">
            <ul class="pagination">
                <li class="page-item">
                    <button class="page-link" :disabled="isButtonDisabled('start', currentPage, maxPageNumber)" @click="getNewPage(currentPage - 1)">
                        <i class="fas fa-lg fa-caret-left"></i>
                    </button>
                </li>
                <li v-for="page in footerPageNumbers" :key="page.id" :class="{ 'active' : page == currentPage }" >
                    <button class="page-link" @click="getNewPage(page)" :disabled="isButtonDisabled(page, currentPage, maxPageNumber)">{{ page }}</button>
                </li>
                <li class="page-item">
                    <button class="page-link" @click="getNewPage(currentPage + 1)" :disabled="isButtonDisabled('end', currentPage, maxPageNumber)">
                        <i class="fas fa-lg fa-caret-right"></i>
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <!-- Modal opened with the Tarif anpassen button. -->
    <div class="modal fade"
         id="modalTeilnehmerTarifChange"
         tabindex="-1"
         role="dialog"
         aria-labelledby="modalTarifChangeTitle">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="modalTarifChangeTitle">Tarif anpassen</h4>
                    <button type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Schließen">
                    </button>
                </div>
                <div class="modal-body">
                    <TeilnehmerTarifChange
                        :changeTarifUrl="props.changeTarifUrl"
                        :getTeilnehmerUrl="props.getTeilnehmerUrl"
                        :isAdmin="props.isAdmin"
                        :teilnehmerID="teilnehmerToChange"
                        @tarifChanged="handleTarifChanged"
                    />
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="futureChangesModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Anstehende Tarifänderungen</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Datum</th>
                  <th>Neuer Tarif</th>
                  <th>Monatspauschale</th>
                  <th v-if="props.isAdmin === 'true'">Löschen</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="change in selectedTeilnehmerChanges"
                    :key="change.id"
                    :class="{'table-warning': getChangeStatus(change.change_date) === 'warning',
                            'table-danger': getChangeStatus(change.change_date) === 'danger'}">
                  <td>{{ formatDate(change.change_date) }}</td>
                  <td>{{ change.tarif_name }}</td>
                  <td>{{ change.price }} €</td>
                  <td v-if="props.isAdmin === 'true'">
                    <button
                        class="btn btn-danger btn-sm"
                        @click="deleteTarifChange(change.id)"
                        :disabled="isLoadingDelete"
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>
.shadow-warning {
  filter: drop-shadow(0 0 3px #ffc107);
}

.shadow-danger {
  filter: drop-shadow(0 0 3px #dc3545);
}

.table-warning {
  background-color: #fff3cd !important;
}

.table-danger {
  background-color: #f8d7da !important;
}
</style>
